import React from "react";

export const Home = React.lazy(() => import("../containers/Home/Home"));
export const BookingStatus = React.lazy(() =>
  import("../containers/BookingStatus/BookingStatus")
);
